import { render, staticRenderFns } from "./CompetitionNav.vue?vue&type=template&id=6e2fb080&"
import script from "./CompetitionNav.vue?vue&type=script&lang=js&"
export * from "./CompetitionNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports